import { useOutletContext } from "react-router-dom"

import type { DeviceDashboardOutletContext } from "types/dashboard.types"

import { deviceTabPlotDefs } from "helpers/config/dashboards"
import { MD_ROW_HEIGHT } from "helpers/utils/constants"
import DeviceDashboard from "widgets/device/DeviceDashboard"
import DevicePosition from "widgets/device/DeviceDashboard/DevicePosition"
import GpsLocationPlot from "widgets/plots/geo/GpsLocationPlot"
import { BodyContainer } from "widgets/styled/containers"

const LOCATION_MAP_HEIGHT = `${3 * MD_ROW_HEIGHT * 0.85}px`

function DeviceData() {
  const { device } = useOutletContext<DeviceDashboardOutletContext>()

  const shouldShowPosition =
    device.device_type === "sentrisense" && device.settings?.installation_type !== "tower"

  const config = {
    type: "deviceTab",
    plotDefs: deviceTabPlotDefs,
  }

  return (
    <BodyContainer disableGutters maxWidth="xl">
      <GpsLocationPlot deviceId={Number(device.id)} mapHeight={LOCATION_MAP_HEIGHT} />
      {shouldShowPosition && <DevicePosition deviceId={device.id} />}
      <DeviceDashboard device={device} config={config} />
    </BodyContainer>
  )
}

export default DeviceData
